// Invisible proof-of-work anti-bot solver (pairs with backend /api/auth/captcha).
// Solves sha256(salt:nonce) with N leading hex zeros - a few hundred ms in real browsers,
// completely invisible to users. No third-party service, no tracking, no keys.
import { api } from "@/lib/api";

const encoder = new TextEncoder();

async function sha256Hex(text) {
  const buf = await crypto.subtle.digest("SHA-256", encoder.encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function solveCaptcha() {
  const { data } = await api.get("/auth/captcha");
  const prefix = "0".repeat(data.difficulty);
  for (let nonce = 0; nonce < 3000000; nonce++) {
    // eslint-disable-next-line no-await-in-loop
    const hash = await sha256Hex(`${data.salt}:${nonce}`);
    if (hash.startsWith(prefix)) {
      return { captchaId: data.captchaId, captchaNonce: String(nonce) };
    }
  }
  throw new Error("Could not complete the anti-bot check. Please refresh and try again.");
}
